module.exports = __webpack_public_path__ + "img/darkbluetdis.6c574bc4.svg";